import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';
import styledC from 'styled-components';

import { stylePropType } from '@adsk/alloy-react-theme';

import TreeNode from '../../TreeNode';

type VirtualizableTreeNodeProps = ComponentProps<typeof TreeNode> & {
  size: number;
  start: number;
};

const VirtualizableTreeNode = styledC(
  TreeNode,
).attrs<VirtualizableTreeNodeProps>((p) => ({
  style: {
    height: p.size,
    transform: `translateY(${p.start}px)`,
  },
}))`
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 300ms;
  width: 100%;
` as React.ForwardRefExoticComponent<VirtualizableTreeNodeProps>;

VirtualizableTreeNode.displayName = 'VirtualizableTreeNode';

VirtualizableTreeNode.propTypes = {
  style: stylePropType,
  className: PropTypes.string,
  size: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
};

export default VirtualizableTreeNode;
